import {
  Action,
  getModule,
  Module,
  Mutation,
  VuexModule
} from "vuex-module-decorators";
import { BookingsAvailability } from "@/api/types";
import { getBookingsAvailability } from "@/api/bookings";
import store from "@/store";
import {
  getServiceResourceIds,
  mergeBookingsAvailability,
  sortAvailabilityByDate
} from "@/utils/staleRefGuards";

export interface BookingsState {
  bookingsAvailability: BookingsAvailability;
}

@Module({ dynamic: true, store, name: "bookings" })
class Bookings extends VuexModule implements BookingsState {
  public bookingsAvailability: BookingsAvailability = {};

  @Action({ rawError: true })
  public async getBookingsAvailability(opts: {
    shopId: string;
    serviceId: string;
    resourceId: string;
    storeAgg: any;
  }) {
    let availableBookingTimes: BookingsAvailability;
    if (opts.resourceId === "Any") {
      const { services } = opts.storeAgg;
      const resources = getServiceResourceIds(services, opts.serviceId);
      const arr = [];
      for (const resource of resources) {
        const singleBookings = await getBookingsAvailability(
          resource,
          opts.serviceId
        );
        if (singleBookings) {
          arr.push(singleBookings);
        }
      }
      availableBookingTimes = mergeBookingsAvailability(arr);
    } else {
      availableBookingTimes = await getBookingsAvailability(
        opts.resourceId,
        opts.serviceId
      );
    }

    this.SET_BOOKINGS_AVAILABILITY(
      sortAvailabilityByDate(availableBookingTimes || {})
    );
  }

  @Mutation
  private SET_BOOKINGS_AVAILABILITY(
    bookingsAvailability: BookingsAvailability
  ) {
    this.bookingsAvailability = bookingsAvailability;
  }
}

export const BookingsModule = getModule(Bookings);
